import React from 'react';
import { connect } from 'react-redux';

import { toggleModal, toggleSpinner } from 'apps/auth/actions/appAction';
import { addExtra } from 'apps/auth/actions/extraAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { getField } from 'apps/auth/components/form-multi/utils';
import { SMS_CONFIRMATION } from 'apps/auth/constants/ExtraNames';
import { AUTH_RESET_PASSWORD_ACTION } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';

import ProfileSmsConfirmModal from './ProfileSmsConfirmModal';

const ChangePasswordPopup = (props) => {
    const changePassword = (e) => {
        e.preventDefault();
        apiFetchData(AUTH_RESET_PASSWORD_ACTION + '?password=false', { password: getField('password', false) }).then((json) => {
            props.updatePageMessages(json.messages);
            if (json.extra && json.extra.smsConfirmation)
                props.addExtra(SMS_CONFIRMATION, json.extra.smsConfirmation).then(() => {
                    props.toggleModal(true, <ProfileSmsConfirmModal popupRef={props.popupRef} />);
                    props.popupRef.current?.close();
                });
        });
    };

    return (
        <SimplePopup withoutBorder popupRef={props.popupRef}>
            <PopupButton
                href={'/auth/changepassword'}
                iconName="retry"
                text={props.settingsPasswordChangeTitle}
                onClick={() => {
                    props.toggleSpinner(true);
                    props.popupRef.current?.close();
                }}
            />
            <PopupButton href={`${AUTH_RESET_PASSWORD_ACTION}?password=false`} iconName="cross" text={props.settingsPasswordRemove} onClick={changePassword} />
        </SimplePopup>
    );
};
const mapStateToProps = (state) => {
    return {
        settingsPasswordChangeTitle: state.messages.pageMessages.settingsPasswordChangeTitle,
        settingsPasswordRemove: state.messages.pageMessages.settingsPasswordRemove,
    };
};
export default connect(mapStateToProps, {
    addExtra,
    updatePageMessages,
    toggleModal,
    toggleSpinner,
})(ChangePasswordPopup);
